<script lang="ts" setup>
import InputMask from 'primevue/inputmask'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputError from '@/components/inputs/InputError.vue'

import { useField } from 'vee-validate'
import { watch } from 'vue'

const props = withDefaults(
  defineProps<{
    id?: string
    label?: string
    mask?: string
    inputName: string
    disabled?: boolean
    viewOnly?: boolean
    placeholder?: string
    type?: 'text' | 'number'
    suffix?: string
    modelValue?: string
  }>(),
  {
    type: 'text',
    disabled: false,
    viewOnly: false,
    placeholder: ''
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: any]
}>()

const { value, errorMessage } = useField<any>(() => props.inputName, undefined, {
  initialValue: props.modelValue,
})

watch(() => props.modelValue, (newValue) => {
  if (newValue !== value.value) {
    value.value = newValue
  }
}, { immediate: true })

watch(value, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<template>
  <div class="flex flex-col">
    <InputLabel :forInput="id">{{ label }}</InputLabel>
    <p class="py-2 font-medium text-[15px] bg-gray-50 rounded-lg px-2" v-if="viewOnly">
      <span v-if="inputName === 'discountPercentage'">{{ value }}%</span>
      <span v-else>
        {{ value }}
      </span>
    </p>

    <template v-else>
      <InputText
        v-if="type === 'text' && !mask"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        :invalid="!!errorMessage"
        v-model="value"
      />

      <InputNumber
        v-if="type === 'number'"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        :invalid="!!errorMessage"
        @input="(e) => (value = e.value as number)"
        mode="decimal"
        :min-fraction-digits="0"
        :max-fraction-digits="5"
        :suffix="suffix"
        :modelValue="value as number"
      />

      <InputMask
        v-if="mask"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        :mask="mask"
        :invalid="!!errorMessage"
        v-model="value"
      />
    </template>

    <InputError v-show="errorMessage">
      {{ errorMessage }}
    </InputError>
  </div>
</template>
<style></style>
